Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div\n  class="ui info message no-drag"\n  style="text-align:center; margin-bottom: 5px;"\n  role="alert"\n  data-noattach="true"\n  data-position="' +
((__t = (ctx.position)) == null ? '' : __t) +
'"\n>\n  Drag and Drop a form component\n</div>\n';
return __p
}